// Trailing actuals — deliberately the quietest element on the page. One
// low-emphasis strip on the surface tint; context, not state.
import { SnapshotTrailingMetric } from "./types";
import { DeltaChip, fmtMetric, useSnapshotTokens } from "./primitives";

export const TrailingStrip = ({
  metrics,
  asOf,
}: {
  metrics: SnapshotTrailingMetric[];
  asOf: string;
}) => {
  const t = useSnapshotTokens();
  return (
    <div
      style={{
        display: "flex",
        gap: 26,
        alignItems: "center",
        padding: "11px 16px",
        background: t.surface3,
        border: `1px solid ${t.line}`,
        borderRadius: 8,
        flexWrap: "wrap",
      }}
    >
      <span
        style={{
          fontSize: 10.5,
          fontWeight: 700,
          letterSpacing: 0.5,
          textTransform: "uppercase",
          color: t.ink4,
        }}
      >
        Trailing actuals
      </span>
      {metrics.map((m) => (
        <span
          key={m.id}
          style={{
            display: "inline-flex",
            alignItems: "baseline",
            gap: 7,
            fontSize: 12.5,
            color: t.ink3,
          }}
        >
          {m.label}
          <b
            style={{
              fontSize: 14,
              color: m.current == null ? t.ink4 : t.ink,
              fontWeight: 700,
            }}
            title={m.current == null ? m.missingReason : undefined}
          >
            {fmtMetric(m)}
          </b>
          <DeltaChip current={m.current} prev={m.prev} unit={m.unit} good="up" />
        </span>
      ))}
      <div style={{ flex: 1 }} />
      <span style={{ fontSize: 11, color: t.ink4 }}>13 weeks ending {asOf}</span>
    </div>
  );
};
